// import * as Realm from 'realm-web'
import { createContext, /*useMemo, useEffect, useState, useRef, useContext, */ ReactNode } from 'react'

// import { config } from '../config'
// import { AuthContext } from './auth.context'

export const DbContext = createContext<any>({})

const Provider = ({ children }: { children: ReactNode }) => {
  return <>{children}</>
  // const { isAuth } = useContext(AuthContext)
  // const fundingsDbEventsRef = useRef<Array<any>>([])
  // const paymentsDbEventsRef = useRef<Array<any>>([])
  // const customersDbEventsRef = useRef<Array<any>>([])
  // const documentsDbEventsRef = useRef<Array<any>>([])
  // const systemUsersDbEventsRef = useRef<Array<any>>([])
  // const bankBalancesDbEventsRef = useRef<Array<any>>([])
  // const customerCompaniesDbEventsRef = useRef<Array<any>>([])
  // const unidentifiedCustomersDbEventsRef = useRef<Array<any>>([])

  // const paymentsRealmApp = useMemo(() => new Realm.App({ id: config.realm.payments.appId as string }), [])
  // const customersRealmApp = useMemo(() => new Realm.App({ id: config.realm.customers.appId as string }), [])
  // const documentsRealmApp = useMemo(() => new Realm.App({ id: config.realm.documents.appId as string }), [])
  // const systemUsersRealmApp = useMemo(() => new Realm.App({ id: config.realm.systemUsers.appId as string }), [])
  // const unidentifiedCustomersRealmApp = useMemo(() => new Realm.App({ id: config.realm.unidentifiedCustomers.appId as string }), [])

  // const [fundingsCollection, setFundingsCollection] = useState<any>(null)
  // const [paymentsCollection, setPaymentsCollection] = useState<any>(null)
  // const [paymentsDbEvents, setPaymentsDbEvents] = useState<Array<any>>([])
  // const [fundingsDbEvents, setFundingsDbEvents] = useState<Array<any>>([])
  // const [documentsCollection, setDocumentsCollection] = useState<any>(null)
  // const [customersCollection, setCustomersCollection] = useState<any>(null)
  // const [documentsDbEvents, setDocumentsDbEvents] = useState<Array<any>>([])
  // const [customersDbEvents, setCustomersDbEvents] = useState<Array<any>>([])
  // const [systemUsersCollection, setSystemUsersCollection] = useState<any>(null)
  // const [systemUsersDbEvents, setSystemUsersDbEvents] = useState<Array<any>>([])
  // const [bankBalancesCollection, setBankBalancesCollection] = useState<any>(null)
  // const [bankBalancesDbEvents, setBankBalancesDbEvents] = useState<Array<any>>([])
  // const [customerCompaniesCollection, setCustomerCompaniesCollection] = useState<any>(null)
  // const [customerCompaniesDbEvents, setCustomerCompaniesDbEvents] = useState<Array<any>>([])
  // const [unidentifiedCustomersCollection, setUnidentifiedCustomersCollection] = useState<any>(null)
  // const [unidentifiedCustomersDbEvents, setUnidentifiedCustomersDbEvents] = useState<Array<any>>([])

  // useEffect(() => {
  //   if (isAuth) {
  //     try {
  //       handleSubscribeToFundingsRealmApp()
  //       handleSubscribeToPaymentsRealmApp()
  //       handleSubscribeToCustomersRealmApp()
  //       handleSubscribeToDocumentsRealmApp()
  //       handleSubscribeToSystemUsersRealmApp()
  //       handleSubscribeToBankBalancesRealmApp()
  //       handleSubscribeToCustomerCompaniesRealmApp()
  //       handleSubscribeToUnidentifiedCustomersRealmApp()
  //     } catch (error) {
  //       console.log('Error DbContext > useEffect', error)
  //     }
  //   } else {
  //     handleLogOutFromRealm()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isAuth])

  // const handleSubscribeToSystemUsersRealmApp = async () => {
  //   try {
  //     if (!systemUsersRealmApp.currentUser || (systemUsersRealmApp.currentUser && !systemUsersRealmApp.currentUser?.isLoggedIn)) {
  //       await systemUsersRealmApp.logIn(Realm.Credentials.anonymous())
  //     }

  //     if (systemUsersRealmApp.currentUser && systemUsersRealmApp.currentUser.isLoggedIn) {
  //       const mongodbSystemUsers = systemUsersRealmApp.currentUser?.mongoClient('mongodb-atlas')
  //       const systemUsersCollectionToWatch = mongodbSystemUsers?.db(config.realm.dbName).collection('systemusers')
  //       setSystemUsersCollection(systemUsersCollectionToWatch)

  //       for await (const systemUsersChange of systemUsersCollectionToWatch.watch()) {
  //         const systemUsersChangeStateUpdated = systemUsersDbEventsRef.current
  //         systemUsersChangeStateUpdated.unshift(systemUsersChange)

  //         setSystemUsersDbEvents(() => [...systemUsersChangeStateUpdated])
  //       }
  //     }
  //   } catch (error: unknown) {
  //     const errorData = error as any
  //     console.log('Error handleSubscribeToSystemUsersRealmApp > ', Object.keys(errorData), errorData)
  //   }
  // }

  // const handleSubscribeToCustomersRealmApp = async () => {
  //   try {
  //     if (!customersRealmApp.currentUser || (customersRealmApp.currentUser && !customersRealmApp.currentUser?.isLoggedIn)) {
  //       await customersRealmApp.logIn(Realm.Credentials.anonymous())
  //     }

  //     if (customersRealmApp.currentUser && customersRealmApp.currentUser.isLoggedIn) {
  //       const mongodbCustomers = customersRealmApp.currentUser?.mongoClient('mongodb-atlas')
  //       const customersCollectionToWatch = mongodbCustomers?.db(config.realm.dbName).collection('customers')
  //       setCustomersCollection(customersCollectionToWatch)

  //       for await (const customersChange of customersCollectionToWatch.watch()) {
  //         const customersChangeStateUpdated = customersDbEventsRef.current
  //         customersChangeStateUpdated.unshift(customersChange)

  //         setCustomersDbEvents(() => [...customersChangeStateUpdated])
  //       }
  //     }
  //   } catch (error: unknown) {
  //     const errorData = error as any
  //     console.log('Error handleSubscribeToCustomersRealmApp > ', Object.keys(errorData), errorData)
  //   }
  // }

  // const handleSubscribeToCustomerCompaniesRealmApp = async () => {
  //   try {
  //     if (!customersRealmApp.currentUser || (customersRealmApp.currentUser && !customersRealmApp.currentUser?.isLoggedIn)) {
  //       await customersRealmApp.logIn(Realm.Credentials.anonymous())
  //     }

  //     if (customersRealmApp.currentUser && customersRealmApp.currentUser.isLoggedIn) {
  //       const mongodbCustomerCompanies = customersRealmApp.currentUser?.mongoClient('mongodb-atlas')
  //       const customerCompaniesCollectionToWatch = mongodbCustomerCompanies?.db(config.realm.dbName).collection('customercompanies')
  //       setCustomerCompaniesCollection(customerCompaniesCollectionToWatch)

  //       for await (const customerCompaniesChange of customerCompaniesCollectionToWatch.watch()) {
  //         const customerCompaniesChangeStateUpdated = customerCompaniesDbEventsRef.current
  //         customerCompaniesChangeStateUpdated.unshift(customerCompaniesChange)

  //         setCustomerCompaniesDbEvents(() => [...customerCompaniesChangeStateUpdated])
  //       }
  //     }
  //   } catch (error: unknown) {
  //     const errorData = error as any
  //     console.log('Error handleSubscribeToCustomerCompaniesRealmApp > ', Object.keys(errorData), errorData)
  //   }
  // }

  // const handleSubscribeToFundingsRealmApp = async () => {
  //   try {
  //     if (!customersRealmApp.currentUser || (customersRealmApp.currentUser && !customersRealmApp.currentUser?.isLoggedIn)) {
  //       await customersRealmApp.logIn(Realm.Credentials.anonymous())
  //     }

  //     if (customersRealmApp.currentUser && customersRealmApp.currentUser.isLoggedIn) {
  //       const mongodbFundings = customersRealmApp.currentUser?.mongoClient('mongodb-atlas')
  //       const fundingsCollectionToWatch = mongodbFundings?.db(config.realm.dbName).collection('customercompanyfundings')
  //       setFundingsCollection(fundingsCollectionToWatch)

  //       for await (const fundingsChange of fundingsCollectionToWatch.watch()) {
  //         const fundingsChangeStateUpdated = fundingsDbEventsRef.current
  //         fundingsChangeStateUpdated.unshift(fundingsChange)

  //         setFundingsDbEvents(() => [...fundingsChangeStateUpdated])
  //       }
  //     }
  //   } catch (error: unknown) {
  //     const errorData = error as any
  //     console.log('Error handleSubscribeToFundingsRealmApp > ', Object.keys(errorData), errorData)
  //   }
  // }

  // const handleSubscribeToDocumentsRealmApp = async () => {
  //   try {
  //     if (!documentsRealmApp.currentUser || (documentsRealmApp.currentUser && !documentsRealmApp.currentUser?.isLoggedIn)) {
  //       await documentsRealmApp.logIn(Realm.Credentials.anonymous())
  //     }

  //     if (documentsRealmApp.currentUser && documentsRealmApp.currentUser.isLoggedIn) {
  //       const mongodbDocuments = documentsRealmApp.currentUser?.mongoClient('mongodb-atlas')
  //       const documentsCollectionToWatch = mongodbDocuments?.db(config.realm.dbName).collection('documents')
  //       setDocumentsCollection(documentsCollectionToWatch)

  //       for await (const documentsChange of documentsCollectionToWatch.watch()) {
  //         const documentsChangeStateUpdated = documentsDbEventsRef.current
  //         documentsChangeStateUpdated.unshift(documentsChange)

  //         setDocumentsDbEvents(() => [...documentsChangeStateUpdated])
  //       }
  //     }
  //   } catch (error: unknown) {
  //     const errorData = error as any
  //     console.log('Error handleSubscribeToDocumentsRealmApp > ', Object.keys(errorData), errorData)
  //   }
  // }

  // const handleSubscribeToUnidentifiedCustomersRealmApp = async () => {
  //   try {
  //     if (!unidentifiedCustomersRealmApp.currentUser || (unidentifiedCustomersRealmApp.currentUser && !unidentifiedCustomersRealmApp.currentUser?.isLoggedIn)) {
  //       await unidentifiedCustomersRealmApp.logIn(Realm.Credentials.anonymous())
  //     }

  //     if (unidentifiedCustomersRealmApp.currentUser && unidentifiedCustomersRealmApp.currentUser.isLoggedIn) {
  //       const mongodbUnidentifiedCustomers = unidentifiedCustomersRealmApp.currentUser?.mongoClient('mongodb-atlas')
  //       const unidentifiedCustomersCollectionToWatch = mongodbUnidentifiedCustomers?.db(config.realm.dbName).collection('unidentifiedcustomers')
  //       setUnidentifiedCustomersCollection(unidentifiedCustomersCollectionToWatch)

  //       for await (const unidentifiedCustomersChange of unidentifiedCustomersCollectionToWatch.watch()) {
  //         const unidentifiedCustomersChangeStateUpdated = unidentifiedCustomersDbEventsRef.current
  //         unidentifiedCustomersChangeStateUpdated.unshift(unidentifiedCustomersChange)

  //         setUnidentifiedCustomersDbEvents(() => [...unidentifiedCustomersChangeStateUpdated])
  //       }
  //     }
  //   } catch (error: unknown) {
  //     const errorData = error as any
  //     console.log('Error handleSubscribeToUnidentifiedCustomersRealmApp > ', Object.keys(errorData), errorData)
  //   }
  // }

  // const handleSubscribeToBankBalancesRealmApp = async () => {
  //   try {
  //     if (!paymentsRealmApp.currentUser || (paymentsRealmApp.currentUser && !paymentsRealmApp.currentUser?.isLoggedIn)) {
  //       await paymentsRealmApp.logIn(Realm.Credentials.anonymous())
  //     }

  //     if (paymentsRealmApp.currentUser && paymentsRealmApp.currentUser.isLoggedIn) {
  //       const mongodbPayments = paymentsRealmApp.currentUser?.mongoClient('mongodb-atlas')
  //       const bankBalancesCollectionToWatch = mongodbPayments?.db(config.realm.dbName).collection('bankbalances')
  //       setBankBalancesCollection(bankBalancesCollectionToWatch)

  //       for await (const bankBalancesChange of bankBalancesCollectionToWatch.watch()) {
  //         const bankBalancesChangeStateUpdated = bankBalancesDbEventsRef.current
  //         bankBalancesChangeStateUpdated.unshift(bankBalancesChange)

  //         setBankBalancesDbEvents([...bankBalancesChangeStateUpdated])
  //       }
  //     }
  //   } catch (error: unknown) {
  //     const errorData = error as any
  //     console.log('Error handleSubscribeToBankBalancesRealmApp > ', Object.keys(errorData), errorData)
  //   }
  // }

  // const handleSubscribeToPaymentsRealmApp = async () => {
  //   try {
  //     if (!paymentsRealmApp.currentUser || (paymentsRealmApp.currentUser && !paymentsRealmApp.currentUser?.isLoggedIn)) {
  //       await paymentsRealmApp.logIn(Realm.Credentials.anonymous())
  //     }

  //     if (paymentsRealmApp.currentUser && paymentsRealmApp.currentUser.isLoggedIn) {
  //       const mongodbPayments = paymentsRealmApp.currentUser?.mongoClient('mongodb-atlas')
  //       const paymentsCollectionToWatch = mongodbPayments?.db(config.realm.dbName).collection('payments')
  //       setPaymentsCollection(paymentsCollectionToWatch)

  //       for await (const paymentsChange of paymentsCollectionToWatch.watch()) {
  //         const paymentsChangeStateUpdated = paymentsDbEventsRef.current
  //         paymentsChangeStateUpdated.unshift(paymentsChange)

  //         setPaymentsDbEvents([...paymentsChangeStateUpdated])
  //       }
  //     }
  //   } catch (error: unknown) {
  //     const errorData = error as any
  //     console.log('Error handleSubscribeToPaymentsRealmApp > ', Object.keys(errorData), errorData)
  //   }
  // }

  // const handleLogOutFromRealm = async () => {
  //   const paymentsRealmAppUser = paymentsRealmApp.currentUser
  //   const customersRealmAppUser = customersRealmApp.currentUser
  //   const documentsRealmAppUser = documentsRealmApp.currentUser
  //   const systemUsersRealmAppUser = systemUsersRealmApp.currentUser
  //   const unidentifiedCustomersRealmAppUser = unidentifiedCustomersRealmApp.currentUser

  //   if (systemUsersRealmAppUser) {
  //     await systemUsersRealmApp.deleteUser(systemUsersRealmAppUser)
  //   }

  //   if (documentsRealmAppUser) {
  //     await documentsRealmApp.deleteUser(documentsRealmAppUser)
  //   }

  //   if (customersRealmAppUser) {
  //     await customersRealmApp.deleteUser(customersRealmAppUser)
  //   }

  //   if (paymentsRealmAppUser) {
  //     await paymentsRealmApp.deleteUser(paymentsRealmAppUser)
  //   }

  //   if (unidentifiedCustomersRealmAppUser) {
  //     await unidentifiedCustomersRealmApp.deleteUser(unidentifiedCustomersRealmAppUser)
  //   }
  // }

  // const value = {
  //   fundingsDbEvents,
  //   paymentsRealmApp,
  //   paymentsDbEvents,
  //   documentsRealmApp,
  //   documentsDbEvents,
  //   customersDbEvents,
  //   customersRealmApp,
  //   paymentsCollection,
  //   fundingsCollection,
  //   systemUsersRealmApp,
  //   documentsCollection,
  //   systemUsersDbEvents,
  //   customersCollection,
  //   bankBalancesDbEvents,
  //   setDocumentsDbEvents,
  //   setCustomersDbEvents,
  //   systemUsersCollection,
  //   bankBalancesCollection,
  //   customerCompaniesDbEvents,
  //   customerCompaniesCollection,
  //   unidentifiedCustomersRealmApp,
  //   unidentifiedCustomersDbEvents,
  //   unidentifiedCustomersCollection
  // }

  // return <DbContext.Provider value={value}>{children}</DbContext.Provider>
}

const DbContextProvider = {
  Provider,
  Consumer: DbContext.Consumer
}

export default DbContextProvider
